import * as Mui from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { sortArrayByName } from "../../../helpers/sortArray";
import {
  Filter,
  GroupFilter,
  MultipleFilter,
} from "../../filter";
import Search from "../../search";
import { IconAdd, IconXlsx } from "../../svg";
import ColumnFilter from "./column-filter";

const TableToolbar = (props) => {
  const {
    title,
    subtitle,
    numSelected,
    search,
    customFilter,
    statusFilter,
    buildingFilter,
    canteenFilter,
    kioskFilter,
    categoryFilter,
    tenantFilter,
    // dateFilter,
    handleSearch,
    handleStatusFilter,
    handleBuildingFilter,
    handleCanteenFilter,
    handleKioskFilter,
    handleCategoryFilter,
    handleTenantFilter,
    handleReset,
    // handleDateFilter,
    permission,
    route,
    createLabel,
    // handleOpenAlert1,
    handleOpenImport,
    headCells,
    enableSearch = true,
    enableStatusFilter,
    enableBuildingFilter,
    enableCanteenFilter,
    enableIndependentCanteenFilter,
    enableKioskFilter,
    enableProductCategoryFilter,
    enableCategoryFilter,
    enableTenantFilter,
    // handleBuiCanFilter,
    enableReset,
    // enableDateFilter,
    // dateFilterMinDate,
    // dateFilterMaxDate,
    enableColumnFilter,

    canteenFilterType,
    enableImport,
    customChoiceList,
    titleTrailing,
    searchPlaceholder,
    toolbarPadding = true
  } = props;
  const { t } = useTranslation();


  // const [showFilter, setShowFilter] = useState(false);
  // const { theme } = useTheme()

  // const hasFilteredTenant = useRef(false);
  // const hasFilteredBuilding = useRef(false);

  // useEffect(() => {
  //   if (!hasFilteredTenant.current && Array.isArray(props?.tenantList) && props?.tenantList?.length === 1) {
  //     handleTenantFilter({ target: { value: props?.tenantList?.[0]?.id } });
  //     hasFilteredTenant.current = true
  //   }

  // }, [props?.tenantList?.length])

  // useEffect(() => {
  //   if (!hasFilteredBuilding.current && Array.isArray(props?.buildings) && props?.buildings?.length === 1) {
  //     const buiId = props.buildings?.[0]?.id;
  //     let canId = null;

  //     const buildingCanteen = props.buildings?.find(
  //       (x) => x.id === buiId
  //     )?.canteen || [];

  //     if (buildingCanteen?.length === 1) {
  //       canId = buildingCanteen?.[0]?.id;
  //     }
  //     handleBuiCanFilter(buiId, canId)

  //     hasFilteredBuilding.current = true;
  //   }
  // }, [props?.buildings?.length]);




  return (
    <Mui.Toolbar className="datatable-filter-bar" style={{ padding: toolbarPadding ? 'auto' : 0 }}>
      <Mui.Box className={`mb-${subtitle ? '2' : '1'}`} width="100%" display="flex" alignItems={"center"} justifyContent={'space-between'}>
        <Mui.Box>
          <Mui.Box display="flex" alignItems={"center"} gridGap={10}>
            <Mui.Typography
              component="h3"
              variant="h3"
              className={`title ${Mui.isWidthDown("sm", props.width) ? "align-self-start" : "center"
                }`}
            >
              {title}
            </Mui.Typography>
            {props.titleSuffix}
          </Mui.Box>

          {subtitle && <Mui.Typography
            component="p"
            variant="body1"
            className="mt-1 text-color-grey"
          >
            {subtitle}
          </Mui.Typography>}
        </Mui.Box>


        <Mui.Box display={'flex'} gridGap={8}>
          {titleTrailing}
          {enableImport ? (
            <Mui.Button
              style={{ margin: "0.5rem 0" }}
              size="small"
              disableElevation
              onClick={handleOpenImport}
              className={`flex-shrink-0 no-color-btn`}
            >
              {t("COMMON.BUTTON.IMPORT")}
              <span className="ml-1 line-height-null">
                <IconXlsx />
              </span>
            </Mui.Button>
          ) : null}
          {permission?.add ? (
            <Mui.Button
              style={{ margin: "0.5rem 0" }}
              color="primary"
              size="small"
              disableElevation
              component={Link}
              to={`${route}/add`}
              className={`btn-default`}
              type="submit"
              variant="contained"
            >
              {createLabel}
              <span className="ml-1 line-height-null">
                <IconAdd />
              </span>
            </Mui.Button>
          ) : null}

          {enableColumnFilter ? <ColumnFilter headers={headCells} /> : null}

        </Mui.Box>
      </Mui.Box>
      <Mui.Box className="w-100">
        <Mui.Box className="w-100" display={'flex'} justifyContent={'space-between'} alignItems={'flex-start'}>
          {/* <Mui.Button
            style={{ margin: "0.5rem 0" }}
            size="small"
            disableElevation
            onClick={() => { setShowFilter(prev => !prev) }}
            className={`flex-shrink-0 no-color-btn`}
          >
            {"Filter"}
            <span className="ml-1 line-height-null">
              {showFilter ? <ExpandLess /> : <ExpandMore />}
            </span>
          </Mui.Button> */}
          <Mui.Box />
          {/* <Mui.Box display={'flex'} gridGap={8}>
            {enableImport ? (
              <Mui.Button
                style={{ margin: "0.5rem 0" }}
                size="small"
                disableElevation
                onClick={handleOpenImport}
                className={`flex-shrink-0 no-color-btn`}
              >
                {t("COMMON.BUTTON.IMPORT")}
                <span className="ml-1 line-height-null">
                  <IconXlsx />
                </span>
              </Mui.Button>
            ) : null}
            {permission?.add ? (
              <Mui.Button
                style={{ margin: "0.5rem 0" }}
                color="primary"
                size="small"
                disableElevation
                component={Link}
                to={`${route}/add`}
                className={`btn-default`}
                type="submit"
                variant="contained"
              >
                {createLabel}
                <span className="ml-1 line-height-null">
                  <IconAdd />
                </span>
              </Mui.Button>
            ) : null}

            {enableColumnFilter ? <ColumnFilter headers={headCells} /> : null}

          </Mui.Box> */}
        </Mui.Box>
      </Mui.Box>


      <Mui.Collapse
        in={true}
        className="w-100"
      >
        <Mui.Box className="w-100" display={'flex'}
        // style={{ border: `1px solid ${theme === 'dark' ? '#ffffff15' : '#00000025'}`, borderRadius: '1rem', padding: '1rem' }}
        >
          <Mui.Box style={{ flex: 1 }}>
            <Mui.Grid container spacing={2}>
              {enableSearch &&
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Search searchPlaceholder={searchPlaceholder} value={search} onSearch={handleSearch} />
                </Mui.Grid>
              }

              {customFilter}

              {enableStatusFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Filter
                    label={t("COMMON.FORM.STATUS")}
                    value={statusFilter}
                    onFilter={handleStatusFilter}
                    options={customChoiceList ?? props.choiceList}
                    displayEmpty={true}
                  />
                </Mui.Grid>
              ) : null}

              {enableTenantFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Filter
                    label={t("TENANT.TITLE")}
                    value={tenantFilter}
                    onFilter={handleTenantFilter}
                    options={props?.tenantList ?? []}
                    displayEmpty={true}
                  />
                </Mui.Grid>
              ) : null}

              {enableBuildingFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Filter
                    label={t("BUILDING.TITLE")}
                    value={buildingFilter}
                    onFilter={handleBuildingFilter}
                    options={props.buildings}
                    displayEmpty={true}
                  />
                </Mui.Grid>
              ) : null}

              {enableIndependentCanteenFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Filter
                    label={t("CANTEEN.TITLE")}
                    value={canteenFilter}
                    onFilter={handleCanteenFilter}
                    options={props?.allCanteens || []}
                    displayEmpty={true}
                  />
                </Mui.Grid>
              ) : null}

              {enableCanteenFilter && buildingFilter ? (
                canteenFilterType !== 'single' ?
                  <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                    <MultipleFilter
                      label={t("CANTEEN.TITLE")}
                      value={canteenFilter}
                      onFilter={handleCanteenFilter}
                      options={sortArrayByName(
                        props.buildings?.find((x) => x.id === buildingFilter)
                          ?.canteen || []
                      )}
                      displayEmpty={true}
                    />
                  </Mui.Grid> :
                  <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                    <Filter
                      label={t("CANTEEN.TITLE")}
                      value={canteenFilter}
                      onFilter={handleCanteenFilter}
                      options={sortArrayByName(
                        props.buildings?.find((x) => x.id.toString() === buildingFilter.toString())
                          ?.canteen || []
                      )}
                      displayEmpty={true}
                    />
                  </Mui.Grid>
              ) : null}

              {enableKioskFilter && canteenFilter && <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                <Filter
                  label={t("KIOSK.TITLE")}
                  value={kioskFilter}
                  onFilter={handleKioskFilter}
                  options={sortArrayByName(
                    props.buildings.flatMap((x) => x.canteen).find((x) => canteenFilter && x.id.toString() === canteenFilter.toString())?.kiosk || []
                  ) ?? []}
                  displayEmpty={true}
                />
              </Mui.Grid>
              }

              {enableProductCategoryFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <GroupFilter
                    label={t("CONFIG_CHOICE_CATEGORY.FORM.CATEGORY")}
                    value={categoryFilter}
                    onFilter={handleCategoryFilter}
                    options={props.productCategories}
                    displayEmpty={true}
                    leftMargin={false}
                  />
                </Mui.Grid>
              ) : null}
              {enableCategoryFilter ? (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Filter
                    label={t("CONFIG_CHOICE_CATEGORY.FORM.CATEGORY")}
                    value={categoryFilter}
                    onFilter={handleCategoryFilter}
                    options={props.configChoiceCategories}
                    displayEmpty={true}
                  />
                </Mui.Grid>

              ) : null}
              {enableReset && (
                <Mui.Grid item xs={12} sm={6} md={4} lg={3}>
                  <Mui.Button
                    size="small"
                    color="primary"
                    type="button"
                    disableElevation
                    onClick={() => { handleReset(); }}
                    className={`flex-shrink-0 pl-2 pr-2 no-color-btn tbl-filter-field search`}
                  >
                    {t("COMMON.RESET")}
                  </Mui.Button>
                </Mui.Grid>
              )}
            </Mui.Grid>
          </Mui.Box>

          {/* {enableDateFilter ? (
            <DateFilter
              label={t("MENU.FORM.DATE")}
              value={dateFilter}
              minDate={dateFilterMinDate}
              maxDate={dateFilterMaxDate}
              onDateChange={handleDateFilter}
            />
          ) : null} */}
        </Mui.Box>
      </Mui.Collapse>

      <Mui.Hidden smUp>
        <Mui.Divider light={true} className="w-100 mb-1" />
      </Mui.Hidden>

      {/* Bulk Selection Action */}
      {/* {numSelected > 0 ? (
          <BulkSelection
            selected={numSelected}
            onDelete={() => handleOpenAlert1()}
          />
        ) : null} */}

      {numSelected === 0 ? (
        <>
          {/* <Mui.Tooltip
              title={t("COMMON.BUTTON.IMPORT")}
              arrow
              placement="bottom-start"
              PopperProps={{
                className:
                  "MuiTooltip-popper MuiTooltip-popperArrow tooltip-popover default-tooltip",
              }}
            >
              <Mui.IconButton
                color="primary"
                variant="outlined"
                className={`btn-icon-square ${
                  Mui.isWidthDown("xs", props.width) ? "" : "ml-2"
                }`}
                onClick={handleOpenImport}
              >
                <IconXlsx />
              </Mui.IconButton>
            </Mui.Tooltip> */}
          {/* {enableImport ? (
              <Mui.Button
                size="small"
                disableElevation
                onClick={handleOpenImport}
                className={`flex-shrink-0 pl-1 no-color-btn ${Mui.isWidthDown("xs", props.width) ? "" : "ml-2"
                  }`}
              >
                {t("COMMON.BUTTON.IMPORT")}
                <span className="ml-1 line-height-null">
                  <IconXlsx />
                </span>
              </Mui.Button>
            ) : null}

            {permission?.add ? (
              <Mui.Button
                color="primary"
                size="small"
                disableElevation
                component={Link}
                to={`${route}/add`}
                className={`btn-default flex-shrink-0 ${Mui.isWidthDown("xs", props.width) ? "" : "ml-2"}`}
                type="submit"
                variant="contained"
              >
                {createLabel}
                <span className="ml-1 line-height-null">
                  <IconAdd />
                </span>
              </Mui.Button>
            ) : null}

            {enableColumnFilter ? <ColumnFilter headers={headCells} /> : null} */}
        </>
      ) : null}

      {/* <Mui.Hidden mdUp>
        <Mui.IconButton
          color="primary"
          variant="outlined"
          className="btn-icon-square ml-2"
          onClick={() => setShowFilter(!showFilter)}
        >
          <IconGear />
        </Mui.IconButton>
      </Mui.Hidden> */}




      <Mui.Hidden smUp>
        <Mui.Divider light={true} className="w-100 mt-1" />
      </Mui.Hidden>

    </Mui.Toolbar>
  );
};
const mapStateToProps = ({ building, configChoiceCategory, shared, tenant, kiosk, productCategory }) => {
  const { choiceList } = shared;
  const { buildings: bui } = building;
  const { tenants: tnt } = tenant;
  const { kiosks: kio } = kiosk;
  const { productCategories } = productCategory
  const { configChoiceCategories } = configChoiceCategory;
  const buildings = sortArrayByName(bui ?? [])
  const kiosks = sortArrayByName(kio ?? [])
  const tenantList = sortArrayByName(tnt ?? [])

  const allCanteens = buildings.flatMap((x) => x.canteen)

  return { choiceList, buildings, productCategories, configChoiceCategories, tenantList, kiosks, allCanteens };
};
export default connect(mapStateToProps, {})(Mui.withWidth()(TableToolbar));
